import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class RecommendationService {

  constructor(private http: HttpClient) {}

  getRecommendations(id: number, type: string, lang: string = 'en-US'): Observable<any> {
    return this.http.get<any>(`${environment.backendUrl}/api/${type}/${id}/recommendations?language=${lang}`);
  }
}


